{
	"deleteGuest": "Deletar convidado",
	"excludeGuest": "Excluir convidado",
	"deleteDescription": "O convidado será excluído permanentimente. Deseja continuar assim mesmo?",
	"emptyText": "Sem dados a serem exibidos.",
	"reports": {
		"goTo": "ir para",
		"clientsReportTable": {
			"filename": "consumo-por-cliente",
			"title": "Consumo por cliente",
			"name": "Nome",
			"phone": "Telefone",
			"zigCode": "ZigCode",
			"cpf": "CPF",
			"appTransactionsValue": "Pago pelo app",
			"bonusTransactionsValue": "Pago com bônus",
			"housePostPaidTransactionsValue": "Pós pago na casa",
			"housePrePaidTransactionsValue": "Pré pago na casa",
			"total": "Total",
			"hasApp": "Tem app",
			"noApp": "Não tem app",
			"seeExtract": "Ver extrato",
			"editData": "Editar dados",
			"invoices": "Notas fiscais",
			"searchClient": "Busque aqui um cliente",
			"customerConsumption": "Consumo por cliente",
			"empty": "Sem dados a serem exibidos."
		},
		"cmvReportTable": {
			"mountableCaps": "MONTÁVEL",
			"mountable": "Produto montável",
			"name": "Nome",
			"section": "Sessão",
			"count": "Quantidade",
			"productUnitCost": "Custo unitário",
			"total": "Custo Total"
		},
		"rappiDiscount": {
			"products": "Produtos",
			"date": "Data",
			"value": "Valor do desconto",
			"employee": "Funcionário que aplicou o desconto",
			"emptyText": "Sem dados a serem exibidos."
		},
		"reserveReportTable": {
			"title": "Detalhes do pacote",
			"downloadTable": "Baixar Tabela",
			"confirmedPeople": "{{value}} clientes confirmados",
			"ticketTooltip": "Ticket médio dos clientes do pacote",
			"total": "Faturamento total",
			"reserveValue": "faturado em valor de pacote",
			"totalProductsValue": "faturado em produtos",
			"tips": "gorjetas",
			"issuedInvoices": "Emissão de nota fiscal",
			"name": "Nome",
			"count": "Quant.",
			"unitValue": "Valor unitário",
			"totalValue": "Valor total",
			"discount": "Desconto",
			"receivedValue": "Valor recebido",
			"noPromotion": "Produtos fora de promoção",
			"discountTooltip": "Eventuais descontos na conta fazem parte desse valor",
			"productName": "Total",
			"packageName": "Nome do Pacote",
			"date": "Data do pacote",
			"products": "Produtos",
			"invitedPeople": "Convidados",
			"confirmedPeopleExcel": "Confirmados",
			"value": "Valor do pacote",
			"revenue": "Faturamento",
			"issued": "Emissão de NF",
			"titleExcel": "pacotes",
			"filenameExcel": "pacotes",
			"promotionName": "Promoção",
			"productNameExcel": "Produto",
			"selledCount": "Quantidade",
			"titleExcelDetails": "detalhes do pacote ",
			"filenameExcelDetails": "datalhes_do_pacote_"
		},
		"stockReportTable": {
			"title": "Transferências de estoque",
			"category": "Transferências de {{product}}",
			"bar": "Bar",
			"time": "Hora",
			"stocker": "Responsável",
			"employeeBar": "Funcionário do bar",
			"quantity": "Quantidade"
		},
		"cashierAdjustmentsReport": {
			"title": "Sangrias e Fundos de Troco",
			"filters": {
				"byAuthor": {
					"label": "Filtrar por Funcionário",
					"placeholder": "Selecione um funcionário"
				},
				"byCashier": {
					"label": "Filtrar por Caixa",
					"placeholder": "Selecione um caixa"
				},
				"byType": {
					"label": "Filtrar por Tipo",
					"placeholder": "Selecione um tipo"
				}
			},
			"table": {
				"columns": {
					"author": "Funcionário",
					"cashier": "Caixa",
					"timestamp": "Data/Hora",
					"type": "Tipo",
					"obs": "Observação",
					"value": "Valor"
				}
			},
			"adjustmentTypes": {
				"bleeding": "Sangria",
				"pettyCash": "Fundo de Troco"
			},
			"cashierAdjustmentForm": {
				"inputLabels": {
					"value": "Valor",
					"obs": "Observação"
				},
				"errors": {
					"emptyValue": "Digite um valor"
				}
			},
			"cashierAdjustmentModal": {
				"title": "Lançar {{adjustmentType}}",
				"notAllowedText": "Essa ação não pode ser realizada quando o evento já foi encerrado."
			},
			"excelFileName": "ajustes-de-caixa-{{timestamp}}",
			"successfullExportMsg": "Planilha exportada com sucesso!",
			"exchangeTotal": "Total em fundo de troco",
			"cashWithdrawal": "Total em sangria"
		}
	}
}
